import script from "./BlogPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPageView.vue?vue&type=script&setup=true&lang=js"

import "./BlogPageView.vue?vue&type=style&index=0&id=b058c7b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b058c7b8"]])

export default __exports__